import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from '@angular/forms'
import{LoopBackAuth, listadosService, validacionService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';

@Component({
  selector: 'datos-complementarios',
  template: `
<form name="form-inscripciones" [formGroup]="datosComplementarios">
  <div class="row">
    <label class="col-sm-2 col-form-label text-right">
      Vive con:<span class="text-danger">*</span> 
    </label>
    <div class="col-sm-4">
      <div
        class="input-group input-group-sm"
        [ngClass]="{'showError': !datosComplementarios.get('vive').valid && datosComplementarios.get('vive').touched}">
          <select
          name="vive"
          class="form-control"
          [style.border-radius]="'0px'"
          formControlName="vive"
          >
          <option [value]="null">SELECCIONE UNA OPCIÓN </option>
          <option *ngFor="let item of vivesCon" [value]="item.id">
            {{item.descripcion | uppercase}}
          </option>
        </select>
      </div>
    </div>
    <label class="col-sm-2 col-form-label text-right">
      Estado Civil: <span class="text-danger">*</span> 
    </label>
    <div class="col-sm-4">
      <div
        class="input-group input-group-sm"
        [ngClass]="{'showError': !datosComplementarios.get('estadoCivil').valid && datosComplementarios.get('estadoCivil').touched}">
          <select
          name="estadoCivil"
          class="form-control"
          [style.border-radius]="'0px'"
          formControlName="estadoCivil"
          >
          <option *ngFor="let item of estadoCiviles" [value]="item.id">{{item.descripcion | uppercase}}</option>
        </select>
      </div>
    </div>
  </div>
  
  <div class="row">
    <label class="col-sm-2 col-form-label text-right">
      Etnia: <span class="text-danger">*</span> 
    </label>
    <div class="col-sm-4">
      <div
        class="input-group input-group-sm"
        [ngClass]="{'showError': !datosComplementarios.get('etnia').valid && datosComplementarios.get('etnia').touched}">
          <select
          name="etnia"
          class="form-control"
          [style.border-radius]="'0px'"
          formControlName="etnia"
          >
          <option *ngFor="let item of etnias" [value]="item.id">{{item.descripcion | uppercase}}</option>
        </select>
      </div>
    </div>
    <label class="col-sm-2 col-form-label text-right">
      Discapacidad:<span class="text-danger">*</span> 
    </label>
    <div class="col-sm-4">
      <div
        class="input-group input-group-sm"
        [ngClass]="{'showError': !datosComplementarios.get('discapasidad').valid && datosComplementarios.get('discapasidad').touched}">
          <select
          name="discapasidad"
          class="form-control"
          [style.border-radius]="'0px'"
          formControlName="discapasidad"
          >
          <option *ngFor="let item of discapacidades" [value]="item.id">{{item.descripcion | uppercase}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row">
    <label class="col-sm-2 col-form-label text-right">
      Nacionalidad: <span class="text-danger">*</span> 
    </label>
    <div class="col-sm-4">
      <div
        class="input-group input-group-sm"
        [ngClass]="{'showError': !datosComplementarios.get('nacionalidad').valid && datosComplementarios.get('nacionalidad').touched}">
          <select
          name="nacionalidad"
          class="form-control"
          [style.border-radius]="'0px'"
          formControlName="nacionalidad"
          >
          <option [value]="null">SELECCIONE UNA OPCIÓN </option>
          <option *ngFor="let item of nacionalidades" [value]="item.id">{{item.descripcion | uppercase}}</option>
        </select>
      </div>
    </div>
  </div>
</form>
  `,
  providers:[LoopBackAuth, listadosService, validacionService, MessageService]
})
export class DatosComplementariosComponent implements OnInit {
  @Input() datosComplementarios: FormGroup
  public nacionalidades: any[]
  public estadoCiviles: any[]
  public etnias: any[]
  public discapacidades: any[]
  public vivesCon: any[]

  constructor(
    private listadosService:listadosService,
    private val:validacionService,
  ) { }

  ngOnInit() {
    
    /** Busco el listado de nacionalidad */
    this.listadosService.grupos('G_NACIONALIDAD').subscribe(
      result =>{
        this.nacionalidades = result.G_NACIONALIDAD.orden
        if(this.datosComplementarios.get('nacionalidad').value == null)
          this.datosComplementarios.patchValue({ nacionalidad : this.val.gruposDefecto(this.nacionalidades,2)})
      }
    )

    /** Busco el listado de estado civil */
    this.listadosService.grupos('G_ESTADO_CIVIL').subscribe(
      result =>{
        console.log("Vive con -->", result)
        this.estadoCiviles = result.G_ESTADO_CIVIL.orden
        if(this.datosComplementarios.get('estadoCivil').value == null)
          this.datosComplementarios.patchValue({ estadoCivil : this.val.gruposDefecto(this.estadoCiviles,2)})
      }
    )

    /** Busco el listado de etnias */
    this.listadosService.grupos('G_ETNIA').subscribe(
      result =>{
        this.etnias = result.G_ETNIA.orden
        if(this.datosComplementarios.get('etnia').value == null)
          this.datosComplementarios.patchValue({ etnia : this.val.gruposDefecto(this.etnias,2)})
      }
    )

    /** Busco el listado de discapacidad */
    this.listadosService.grupos('G_DISCAPACIDAD').subscribe(
      result =>{
        this.discapacidades = result.G_DISCAPACIDAD.orden
        if(this.datosComplementarios.get('discapasidad').value == null)
          this.datosComplementarios.patchValue({ discapasidad : this.val.gruposDefecto(this.discapacidades,2)})
      }
    )
    /** Busco el listado de vive con */
    this.listadosService.tiposParentesco().subscribe(
      result =>{
        this.vivesCon = result
      }
    )

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-complementarios.component.ts